import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-navy flex items-center justify-center p-8">
                    <div className="text-center">
                        <p className="font-display text-2xl font-bold text-white">
                            Something went wrong
                        </p>
                        <button
                            data-testid="error-reload-button"
                            onClick={() => window.location.reload()}
                            className="mt-6 px-6 py-3 rounded-full bg-gold text-navy font-semibold hover:bg-gold-hover transition-colors"
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        const onScrollTo = () => {
            if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
            else window.scrollTo(0, 0);
        };
        window.addEventListener("sn:scrolltop", onScrollTo);
        return () => window.removeEventListener("sn:scrolltop", onScrollTo);
    }, []);

    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <ScrollManager />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
